var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthCareCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 114,
    viewBox: "0 0 335 114",
    width: 335,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335 0v114h-335v-114z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159 0c6.075132 0 11 4.92486775 11 11v92c0 6.075132-4.924868 11-11 11h-159v-114z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.266 0v1.54h-5.544v2.548h4.914v1.54h-4.914v2.632h5.614v1.54h-7.336v-9.8z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.946 0 1.708 2.478 1.708-2.478h1.806l-2.604 3.612 2.716 3.78h-1.848l-1.82-2.632-1.806 2.632h-1.806l2.702-3.766-2.604-3.626z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.214 0c1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v3.388h-1.694v-9.632h1.694v1.232c.546-.77 1.316-1.386 2.52-1.386zm-.406 1.47c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366v-.028c0-1.428-.966-2.366-2.114-2.366z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.764 2.744v7.392h-1.694v-7.392zm.056-2.744v1.61h-1.82v-1.61z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.11013588.00075424.20186412.00216154v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814h-1.694v-7.392h1.694v1.666c.462-1.106 1.316-1.862 2.618-1.806z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.82 0 2.086 5.488 1.918-5.488h1.764l-2.94 7.602c-.588 1.512-1.246 2.072-2.436 2.072-.7 0-1.232-.168-1.75-.448l.574-1.26c.308.168.644.28.994.28.476 0 .77-.21 1.05-.84l-3.08-7.406z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.654 0c3.08 0 5.208 2.114 5.208 4.872v.028c0 2.758-2.128 4.9-5.208 4.9h-3.654v-9.8zm0 1.568h-1.932v6.664h1.932c2.058 0 3.402-1.386 3.402-3.304v-.028c0-1.918-1.344-3.332-3.402-3.332z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282v4.382h-1.652v-.924c-.504.602-1.274 1.078-2.408 1.078-1.386 0-2.618-.798-2.618-2.282v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308v-.182c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462l-.448-1.33c.812-.364 1.61-.602 2.786-.602zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504c-.434-.168-1.008-.294-1.68-.294z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.632 0v2.03h1.988v1.456h-1.988v3.626c0 .658.336.924.91.924.378 0 .714-.084 1.05-.252v1.386c-.42.238-.882.378-1.526.378-1.246 0-2.128-.546-2.128-2.17v-3.892h-.938v-1.456h.938v-2.03z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.596 0 5.25 6.776v-6.776h1.694v9.8h-1.442l-5.404-6.972v6.972h-1.694v-9.8z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282v4.382h-1.652v-.924c-.504.602-1.274 1.078-2.408 1.078-1.386 0-2.618-.798-2.618-2.282v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308v-.182c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462l-.448-1.33c.812-.364 1.61-.602 2.786-.602zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504c-.434-.168-1.008-.294-1.68-.294z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718h-1.694v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172h-1.694v-4.214c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172h-1.694v-7.392h1.694v1.12c.476-.658 1.12-1.274 2.254-1.274 1.064 0 1.82.518 2.212 1.302.588-.784 1.372-1.302 2.492-1.302z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.054 0c1.806 0 2.898.63 3.836 1.526l-1.106 1.274c-.784-.728-1.624-1.218-2.744-1.218-1.862 0-3.234 1.54-3.234 3.458v.028c0 1.918 1.358 3.472 3.234 3.472 1.204 0 1.974-.476 2.814-1.26l1.106 1.12c-1.022 1.064-2.142 1.736-3.976 1.736-2.856 0-4.984-2.226-4.984-5.04v-.028c0-2.786 2.086-5.068 5.054-5.068z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.368 0c1.232 0 2.198.364 2.828.98.518.532.812 1.26.812 2.114v.028c0 1.61-.966 2.576-2.324 2.968l2.646 3.71h-2.044l-2.408-3.416h-2.156v3.416h-1.722v-9.8zm-.14 1.568h-2.506v3.29h2.52c1.232 0 2.016-.644 2.016-1.638v-.028c0-1.05-.756-1.624-2.03-1.624z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.596 0 5.25 6.776v-6.776h1.694v9.8h-1.442l-5.404-6.972v6.972h-1.694v-9.8z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.52336449 0 8.52336451 17.1238017h-17.046729z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.52336449 0 8.52336451 17.1238017h-17.046729z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.288 0v8.46h-1.464v-6.96l-1.512.42-.312-1.2 2.268-.72z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.52 0v5.544c0 .996-.3 1.74-.792 2.232s-1.2.744-2.04.744c-1.296 0-2.136-.6-2.688-1.356l.972-1.008c.492.636.984.996 1.692.996.792 0 1.332-.528 1.332-1.656v-5.496z"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.064 0 3.696 8.46h-1.56l-.852-2.028h-3.972l-.864 2.028h-1.512l3.696-8.46zm-.708 1.764-1.44 3.36h2.892z"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.368 0 4.5 5.808v-5.808h1.452v8.4h-1.236l-4.632-5.976v5.976h-1.452v-8.4z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.672 0c2.196 0 3.648 1.92 3.648 4.32v.024c0 2.4-1.464 4.344-3.672 4.344s-3.648-1.92-3.648-4.32v-.024c0-2.4 1.464-4.344 3.672-4.344zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012s2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.832 0v1.308h-3.756l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64v.024c0 1.716-1.26 2.844-3.12 2.844-1.284 0-2.292-.516-3.084-1.284l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588.24-4.116z"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.52 0v5.544c0 .996-.3 1.74-.792 2.232s-1.2.744-2.04.744c-1.296 0-2.136-.6-2.688-1.356l.972-1.008c.492.636.984.996 1.692.996.792 0 1.332-.528 1.332-1.656v-5.496z"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.94 0c.948 0 1.656.252 2.1.708.468.456.684 1.128.684 1.956v3.756h-1.416v-.792c-.432.516-1.092.924-2.064.924-1.188 0-2.244-.684-2.244-1.956v-.024c0-1.368 1.068-2.04 2.616-2.04.708 0 1.212.108 1.704.264v-.156c0-.9-.552-1.38-1.572-1.38-.708 0-1.236.156-1.812.396l-.384-1.14c.696-.312 1.38-.516 2.388-.516zm-.036 3.456c-.936 0-1.488.396-1.488 1.056v.024c0 .612.54.96 1.236.96.96 0 1.692-.552 1.692-1.356v-.432c-.372-.144-.864-.252-1.44-.252z"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.56 0 1.788 4.704 1.644-4.704h1.512l-2.52 6.516c-.504 1.296-1.068 1.776-2.088 1.776-.6 0-1.056-.144-1.5-.384l.492-1.08c.264.144.552.24.852.24.408 0 .66-.18.9-.72l-2.64-6.348z"
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.332 0c1.548 0 2.484.54 3.288 1.308l-.948 1.092c-.672-.624-1.392-1.044-2.352-1.044-1.596 0-2.772 1.32-2.772 2.964v.024c0 1.644 1.164 2.976 2.772 2.976 1.032 0 1.692-.408 2.412-1.08l.948.96c-.876.912-1.836 1.488-3.408 1.488-2.448 0-4.272-1.908-4.272-4.32v-.024c0-2.388 1.788-4.344 4.332-4.344z"
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.512 2.352v6.336h-1.452v-6.336zm.048-2.352v1.38h-1.56v-1.38z"
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.256 0v1.74h1.704v1.248h-1.704v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216v1.188c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86v-3.336h-.804v-1.248h.804v-1.74z"
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.508 0v.996l-3.66 4.152h3.66v1.188h-5.508v-.996l3.66-4.152h-3.528v-1.188z"
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408h-4.656c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188-1.836 0-3.252-1.332-3.252-3.288v-.024c0-1.812 1.284-3.3 3.096-3.3zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.432 0c1.428 0 2.256.96 2.256 2.424v4.044h-1.452v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572v3.576h-1.452v-6.336h1.452v.972c.408-.588.996-1.104 1.98-1.104z"
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.288 0v8.46h-1.464v-6.96l-1.512.42-.312-1.2 2.268-.72z"
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664-1.464 0-2.508-.612-3.216-1.476l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412h-3.636v-1.284z"
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.552 0v1.428h-3.552v-1.428z"
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.928 0v5.364h1.2v1.212h-1.2v1.884h-1.416v-1.884h-4.236l-.276-1.056 4.668-5.52zm-1.416 2.04-2.76 3.324h2.76z"
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.832 0v1.308h-3.756l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64v.024c0 1.716-1.26 2.844-3.12 2.844-1.284 0-2.292-.516-3.084-1.284l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588.24-4.116z"
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888-.636-.636-1.02-1.512-1.02-3.204v-.024c0-2.568 1.224-4.572 3.6-4.572zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.904 0v1.116l-3.78 7.284h-1.668l3.768-7.104h-4.224v-1.296z"
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.204 0c1.68 0 2.916.972 2.916 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436s-3.204-.96-3.204-2.412v-.024c0-1.008.564-1.644 1.512-2.04-.708-.372-1.224-.936-1.224-1.872v-.024c0-1.284 1.236-2.268 2.916-2.268zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26v-.024c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.132 0c1.056 0 1.74.3 2.34.888.612.624 1.008 1.548 1.008 3.204v.024c0 2.7-1.332 4.572-3.6 4.572-1.164 0-1.98-.42-2.688-1.008l.804-1.128c.636.528 1.2.792 1.92.792 1.488 0 2.028-1.536 2.04-2.652-.468.564-1.116.9-1.98.9-1.788 0-2.976-1.044-2.976-2.664v-.024c0-1.644 1.272-2.904 3.132-2.904zm.012 1.272c-1.044 0-1.668.696-1.668 1.56v.024c0 .876.672 1.5 1.716 1.5 1.068 0 1.704-.696 1.704-1.512v-.024c0-.876-.684-1.548-1.752-1.548z"
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.064 0 3.696 8.46h-1.56l-.852-2.028h-3.972l-.864 2.028h-1.512l3.696-8.46zm-.708 1.764-1.44 3.36h2.892z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(81.831858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h170v114h-170z",
    fill: "#f1f5bf"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(269.26 14.739823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.336v9.8h-7.336z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(277.8 17.147823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.28v7.392h-7.28z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(286.564 16.993823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.644v9.786h-7.644z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(295.986 14.403823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.82v10.136h-1.82z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(299.962 17.004907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.312v7.53491578h-4.312z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(305.044 17.147823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.588v9.674h-7.588z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(269.26 29.739823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.862v9.8h-8.862z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(279.522 32.049823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.678v7.644h-6.678z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(287.572 30.117823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.62v9.548h-4.62z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(293.298 31.993823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.26 14.288496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.54v9.8h-8.54z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "translate(10.374 2.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.678v7.644h-6.678z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(19.082 2.254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.242v7.546h-11.242z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(31.976 2.254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.826 43.120496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.96v10.136h-8.96z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(10.766 .168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.33v9.8h-8.33z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(20.888 .168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.54v9.8h-8.54z",
    fill: "#242934"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "matrix(0 -1 1 0 243.316902 28.317757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h17.046729v17.1238017h-17.046729z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "matrix(0 1 -1 0 88.440703 11.626168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h17.046729v17.1238017h-17.046729z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "matrix(0 1 -1 0 88.440703 40.626168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h17.046729v17.1238017h-17.046729z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.835858 14.456)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(8.256 .084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "translate(16.548 .144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.52v8.52h-5.52z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "translate(23.076 .084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.76v8.46h-8.76z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    transform: "translate(33.276 .144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.4h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    transform: "translate(5.706 12.024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    transform: "translate(13.158 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.32v8.688h-7.32z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "translate(21.63 12.024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)",
    transform: "translate(28.962 12.144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.204v8.544h-6.204z",
    fill: "#242934"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "translate(92.083858 14.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.52v8.52h-5.52z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)",
    transform: "translate(99.043858 16.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.724v6.552h-5.724z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(105.667858 16.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.504v8.292h-6.504z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    transform: "translate(116.815858 14.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.68v8.688h-7.68z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    transform: "translate(125.899858 14.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.56v8.688h-1.56z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)",
    transform: "translate(128.803858 14.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.96v8.184h-3.96z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    transform: "translate(134.263858 14.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.56v8.688h-1.56z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    transform: "translate(137.383858 16.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.508v6.336h-5.508z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    transform: "translate(143.863858 16.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.132v6.612h-6.132z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)",
    transform: "translate(151.459858 16.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.688v6.468h-5.688z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    transform: "translate(92.143858 44.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)",
    transform: "translate(97.171858 44.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)",
    transform: "translate(104.455858 44.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.156v8.544h-6.156z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(112.027858 48.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.552v1.428h-3.552z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)",
    transform: "translate(116.683858 44.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.128v8.46h-7.128z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)",
    transform: "translate(124.999858 44.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.204v8.544h-6.204z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)",
    transform: "translate(132.595858 44.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.48v8.688h-6.48z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(140.455858 48.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.552v1.428h-3.552z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)",
    transform: "translate(145.015858 44.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.904v8.4h-5.904z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)",
    transform: "translate(151.963858 44.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.408v8.64h-6.408z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    transform: "translate(159.595858 44.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.48v8.688h-6.48z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)",
    transform: "translate(167.119858 44.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.76v8.46h-8.76z",
    fill: "#242934"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCareCard);
export default __webpack_public_path__ + "static/media/health_care_card.8e0f3cba37132994f98f6f286278839f.svg";
export { ForwardRef as ReactComponent };